import React, { Component, useEffect, useState } from "react";
import "./CorrelationTable.css";

function colorChannelMixer(colorChannelA, colorChannelB, amountToMix) {
  var channelA = colorChannelA * amountToMix;
  var channelB = colorChannelB * (1 - amountToMix);
  return parseInt(channelA + channelB);
}

function colorMixer(rgbA, rgbB, amountToMix) {
  var r = colorChannelMixer(rgbA[0], rgbB[0], amountToMix);
  var g = colorChannelMixer(rgbA[1], rgbB[1], amountToMix);
  var b = colorChannelMixer(rgbA[2], rgbB[2], amountToMix);
  return "rgb(" + r + "," + g + "," + b + ")";
}

const CorrelationTable = (props) => {
  console.log(props.tableData);
  if (props.tableData.length > 1) {
    const tableData = props.tableData.map((row, index) => {
      return { rw: row, tag: props.tickers[index] };
    });
    return (
      <div data-testid="CorrelationTable" className="CorrelationTable">
        <table border="1">
          <thead>
            <tr>
              <th>Tickers</th>
              {props.tickers.map((el) => (
                <th>{el.value}</th>
              ))}
            </tr>
          </thead>

          {tableData.map((row, index) => (
            <tr>
              <td>{row.tag.label}</td>
              {row.rw.map((el) => (
                <td
                  style={{
                    backgroundColor: colorMixer(
                      [0, 255, 0],
                      [255, 0, 0],
                      (el + 1.0) / 2.0
                    ),
                  }}
                >
                  {el}
                </td>
              ))}
            </tr>
          ))}
        </table>
      </div>
    );
  } else {
    return (
      <div data-testid="CorrelationTable" className="CorrelationTable"></div>
    );
  }
};

export default CorrelationTable;
